import CustomSlider from "../../componets/CustomSlider";
import printDesignAndServiceSliderData from "../../data/printDesignAndServiceSlider.json";

export default function Section3() {
  return (
    <div
      className="w-full section3 bg-[#db4437]"
      style={{
        backgroundColor: "linear-gradient(180deg,transparent 0,rgba(0,0,0,.5))",
      }}
    >
      <div className="w-full section3-container">
        <div className="md:w-[750px] lg:w-[970px] xl:w-[1170px] mx-auto px-[15px] pt-[35px] xl:pt-0">
          <h2 className="text-[24px] md:text-[34px] font-bold text-white leading-[40px] text-center py-[0.67em]">
            Our Portfolio
          </h2>
        </div>
        <div id="slider1" className="relative w-full overflow-hidden pt-[25px]">
          <CustomSlider slides={printDesignAndServiceSliderData} />
        </div>
      </div>
    </div>
  );
}
